/* eslint-disable react/prop-types */
import GridList from "@/components-library/widgets/grid-list";
import classes from "./correlated-services-list.module.scss";
import classNames from "classnames";
import CardViewCorrelatedService from "./card-view-correlated-service";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
const NO_ITEMS_FOUND =
  "La soluzione selezionata non presenta servizi correlati";
function CorrelatedServicesList({
  services,
  fromAdmin,
  allAnnouncements,
  announcement,
  offer,
  className,
}) {
  const itemComponent = (
    <CardViewCorrelatedService
      fromAdmin={fromAdmin}
      allAnnouncements={allAnnouncements}
      announcement={announcement}
      offer={offer}
    />
  );
  if (services?.length) {
    return (
      <div className={classNames(classes.container, className)}>
        <GridList columns={3} items={services} itemComponent={itemComponent} />
      </div>
    );
  } else {
    return (
      <Flex
        align="center"
        direction="column"
        justify="center"
        className={classes.container}
      >
        <Label
          weight="bold"
          tag="h5"
          color="secondary"
          align="start"
          className={classes.title}
        >
          {NO_ITEMS_FOUND}
        </Label>
      </Flex>
    );
  }
}

export default CorrelatedServicesList;
